import moment from "moment";

export const mapStartDatePeriodLast = (startDate) =>{
    return moment(startDate).subtract(1, "years").format("DD/MM/YYYY")
}
